"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationArrows = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _react = require("react");
var _common = require("../../common");
var _carouselClasses = require("./carouselClasses");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const NavigationArrows = ({
  instanceRef,
  lastSlideVisible,
  slider,
  slidesCount,
  navigation,
  pagination,
  mode = {
    type: 'sides'
  }
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isAtTheEnd, setIsAtTheEnd] = (0, _react.useState)(false);
  const [isAtTheStart, setIsAtTheStart] = (0, _react.useState)(true);
  const [shouldHideArrowsOnInit, setShouldHideArrowsOnInit] = (0, _react.useState)(false);
  const currentSlide = (0, _lodash.default)(instanceRef, 'current.track.details.rel', 0);
  const createHandler = (0, _react.useCallback)(type => event => {
    event.stopPropagation();
    const index = (0, _utils.getIndex)({
      instanceRef,
      isAtTheEnd,
      isAtTheStart,
      setIsAtTheEnd,
      setIsAtTheStart,
      slider,
      slidesCount,
      type
    });
    instanceRef.current?.moveToIdx(index);
  }, [instanceRef, isAtTheEnd, isAtTheStart, slider, slidesCount]);
  const onNextClick = createHandler('next');
  const onPreviousClick = createHandler('previous');
  const shouldShowPrevious = (0, _react.useMemo)(() => (0, _utils.shouldShowPreviousArrow)({
    currentSlide,
    slider
  }), [currentSlide, slider]);
  const shouldShowNext = (0, _react.useMemo)(() => (0, _utils.shouldShowNextArrow)({
    lastSlideVisible,
    slidesCount,
    currentSlide,
    slider
  }), [lastSlideVisible, slidesCount, currentSlide, slider]);
  (0, _react.useEffect)(() => {
    setShouldHideArrowsOnInit(!shouldShowPrevious && !shouldShowNext);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to run this only on mount to set the initial state and when slidesCount or slider changes
  }, [slidesCount, slider]);
  if (mode.type === 'compact') {
    if (shouldHideArrowsOnInit) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CompactButtonsContainer, {
      className: _carouselClasses.carouselClasses.compactButtonsRoot,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        "aria-label": "\u2190",
        "data-testid": getTestId(_common.CAROUSEL_PREVIOUS_ARROW),
        variant: "contained",
        color: "secondary",
        disabled: !shouldShowPrevious,
        onClick: onPreviousClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        "aria-label": "\u2192",
        "data-testid": getTestId(_common.CAROUSEL_NEXT_ARROW),
        variant: "contained",
        color: "secondary",
        disabled: !shouldShowNext,
        onClick: onNextClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shouldShowPrevious ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PreviousArrow, {
      "aria-label": "\u2190",
      "data-testid": getTestId(_common.CAROUSEL_PREVIOUS_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      size: navigation?.size,
      onClick: onPreviousClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
    }) : null, shouldShowNext ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NextArrow, {
      "aria-label": "\u2192",
      "data-testid": getTestId(_common.CAROUSEL_NEXT_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      size: navigation?.size,
      onClick: onNextClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
    }) : null]
  });
};
exports.NavigationArrows = NavigationArrows;
//# sourceMappingURL=NavigationArrows.js.map